import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { Title } from "react-admin";
import  HeroImage from "./images/ci-hero.png"
import CollectionsImage from "./images/ci-product-collections.png"
import AssociateIpad from "./images/two-people-ipad.jpeg";
import CustomerDetails from "./images/customer-details.png";

const ConciergeWelcomePage = () => (
  <Box sx={{ padding: "20px" }}>
    <Title title="Welcome to Concierge AI" />
    {/* Hero Section */}
    <Card
      sx={{
        marginBottom: "20px",
        textAlign: "center",
        padding: "40px",
        boxShadow: "none",
        borderRadius: "12px",
      }}
    >
      <img
        src={HeroImage}
        alt="Concierge AI"
        style={{ width: "80%", height: "auto", objectFit: "contain", marginBottom: "20px" }}
      />

      <Typography
        variant="h2"
        component="h1"
        gutterBottom
        sx={{ fontWeight: "bold", fontSize: "2.5rem", lineHeight: "1.2" }}
      >
        Make Every Brand Experience Personal and Intelligent with Concierge AI
      </Typography>
      <Typography
        variant="h6"
        component="p"
        gutterBottom
        sx={{  marginBottom: "20px" }}
      >
        An AI-driven extension of the Concierge Solution, Concierge AI offers next-level
        analytics, smart assistants, and immediate insights into your customers that go way beyond Clienteling
      </Typography>
    </Card>

    {/* Key Features Section */}
    <Grid container spacing={2} sx={{ display: "flex", alignItems: "stretch" }}>
    
      {/* First Row */}
      <Grid item xs={12} md={6} sx={{ display: "flex" }}>
        <Card
          sx={{
            flexGrow: 1,
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src={CollectionsImage}
              alt="AI Assistant"
              style={{
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
              }}
            />

            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", textAlign: "center", marginTop: "40px" }}
            >
              AI Assistant for Retail
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{  textAlign: "center" }}
            >
            Your personal associate assistant is here. From
              automating routine tasks to offering real-time advice, Concierge AI’s
              assistant is designed to make managing your customer engagement simpler and
              more effective. Ask questions, receive recommendations, and
              automate tasks.
              </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card
          sx={{
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src={CustomerDetails}
              alt="Customer Intelligence"
              style={{
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
                maxHeight: "475px",
              }}
            />

            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", textAlign: "center", marginTop: "20px" }}
            >
              Intelligence Customer Profiles
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{ textAlign: "center" }}
            >
               The most complete view of your customer available with dimensions of information from all of your applications and AI enhanced
               analysis and recommendations... All in an intuitive, always on, always available mobile experience. 
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* Second Row */}
      <Grid item xs={12} md={6} sx={{ display: "flex" }}>
        <Card
          sx={{
            flexGrow: 1,
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src="https://madmobile.com/wp-content/uploads/2022/08/cake_mm_restaurant-reporting-by-cake.webp"
              alt="Advanced Analytics"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
              }}
            />

            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", textAlign: "center", marginTop: "20px" }}
            >
              Advanced Analytics & Reports
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{  textAlign: "center" }}
            >
              Unlock the power of your data. Concierge AI delivers
              real-time insights and analytics, helping you optimize your
              operations, track sales trends, and monitor customer preferences.
              See the bigger picture with easy-to-read reports and dashboards
              that bring clarity to your decision-making.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
     
      <Grid item xs={12} md={6}>
        <Card
          sx={{
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src={AssociateIpad}
              alt="Knowledge Base"
              style={{
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
                maxHeight: "475px",
              }}
            />

            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", textAlign: "center", marginTop: "20px" }}
            >
              Knowledge Base in AI Chat
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{  textAlign: "center" }}
            >
              Get instant access to your organization's Knowledge Base right
              within the Concierge AI assistant. Whether you are looking for specific training or general best practices, 
              Concierge AI makes is all available simply by asking a question.
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* Third Row */}
      <Grid item xs={12} md={6} sx={{ display: "flex" }}>
        <Card
          sx={{
            flexGrow: 1,
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src="https://madmobile.com/wp-content/uploads/2022/08/cake_mm_restaurant-reporting-by-cake.webp"
              alt="Advanced Analytics"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
              }}
            />

            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold",  textAlign: "center", marginTop: "20px" }}
            >
              Advanced Analytics & Reports
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{ textAlign: "center" }}
            >
              Unlock the power of your data. Concierge AI delivers
              real-time insights and analytics, helping you optimize your
              operations, track sales trends, and monitor customer preferences.
              See the bigger picture with easy-to-read reports and dashboards
              that bring clarity to your decision-making.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
     
      <Grid item xs={12} md={6}>
        <Card
          sx={{
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
          <img
              src="https://res.cloudinary.com/dcppnhptx/image/upload/v1729139045/Build_Hero_Illustration_d5ee5v.png"
              alt="Integrations"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
              }}
            />
            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", textAlign: "center", marginTop: "20px" }}
            >
              Easy Integrations
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{  textAlign: "center" }}
            >
              Simple integrations with your favorite apps and services, where ever you keep consumer data.  Easily create
              and configure your own integrations with Concierge AI.  With many connectors available out of the box, or add your own!
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

  </Box>
);

export default ConciergeWelcomePage;